/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class CodeApi {
    static getInstance() {
        if (!this.instance) this.instance = new CodeApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取客户、平台编码列表
    async getCodeList (param,num,size){
        let url = `/api/v1/page/dict/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取车厂编码列表
    async getFactoryCodeList (param,num,size){
        let url = `/api/v1/page/manufacturer/mapping/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取车型编码列表
    async getModelCodeList (param,num,size){
        let url = `/api/v1/page/mapping/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }
    

    // 新增编码
    async addCode (param){
        let url = `/api/v1/page/dict`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 删除客户、平台编码
    async deleteCode (id){
        let url = `/api/v1/page/dict/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 删除车厂编码
    async deleteFactoryCode (id){
        let url = `/api/v1/page/dict/manufacturer/mapping/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 删除车型编码
    async deleteModelCode (id){
        let url = `/api/v1/page/dict/model/mapping/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 编辑客户、平台编码
    async editCode (param, id){
        let url = `/api/v1/page/dict/${id}`
        let result = await this.getData(url,param,'PUT')
        return result
    }

    // 编辑车厂编码
    async editFactoryCode (param, id){
        let url = `/api/v1/page/dict/manufacturer/mapping/${id}`
        let result = await this.getData(url,param,'PUT')
        return result
    }

    // 编辑车型编码
    async editModelCode (param, id){
        let url = `/api/v1/page/dict/model/mapping/${id}`
        let result = await this.getData(url,param,'PUT')
        return result
    }

    // 获取条件查询-客户、平台下拉列表
    async getCustomerOpt (param){
        let url = `/api/v1/page/mapping/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取条件查询-车厂下拉列表
    async getFactoryOpt (param){
        let url = `/api/v1/page/manufacturer/mapping/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取新增车型-车厂下拉列表
    async getFactoryOpt2 (param){
        // let url = `/api/v1/page/mapping/query`
        let url = `/api/v1/page/manufacturer/mapping/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取客户、平台 下拉列表
    async getParentOpt (param){
        let url = `/api/v1/page/dict/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 导出
    async exportCustomer (id, app_id){
        let url = `/api/v1/page/mapping/export?customer_id=${id}&app_id=${app_id}`
        let result = await this.getData(url,{},'GET','application/octet-stream')
        return result
    }

    // 获取当前最大编码
    async getCurrentMaxCode (param){
        let url = `/api/v1/page/dict/maxcode`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取扫码记录
    async getScanRecord (param,num,size){
        let url = `/api/v1/page/mcu/active/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }
}

export {
    CodeApi
}